import PasswordReset from 'components/Section/PasswordReset';
import LandingLayout from 'layouts/LandingLayout';

const ResetPassword: React.FC = () => (
  <LandingLayout>
    <PasswordReset />
  </LandingLayout>
);

export default ResetPassword;
